import dayjs from 'dayjs';
import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from 'zustand/middleware';
import {
  FIXED_RANGE_TIME,
  LAST7DAYS_RANGE_TIME,
  getLastXdayUnix,
  preconfigDateList,
  todayUnix
} from 'components/common/CFDatePicker/config';

// The Transactions date range outlives a visit to another menu, so the counters
// and the list come back on the range the user picked. Filter panel values are
// not kept: the panel form cannot show them again.
export const useTransactionFilterStore = createWithEqualityFn(
  persist(
    set => ({
      rangeTime: null,
      dates: null,
      includeToday: false,
      setDateRange: ({ rangeTime, dates }) =>
        set({
          rangeTime,
          dates,
          includeToday: dates?.[1] === dayjs().endOf('day').unix()
        })
    }),
    {
      name: 'transaction-filter-storage'
    }
  ),
  Object.is
);

const toUnixRange = ([start, end]) => [
  dayjs(start).startOf('day').unix(),
  dayjs(end).endOf('day').unix()
];

// getInitialDateRange restores the stored range. A relative range such as
// "Last 7 days" is recalculated from today rather than replayed as fixed dates.
export const getInitialDateRange = () => {
  const { rangeTime, dates, includeToday } = useTransactionFilterStore.getState();

  if (!rangeTime || !dates) {
    return { dates: [getLastXdayUnix(6), todayUnix], rangeTime: LAST7DAYS_RANGE_TIME };
  }

  const config = preconfigDateList.find(item => item.id === rangeTime);
  if (rangeTime === FIXED_RANGE_TIME || !config) {
    return { dates, rangeTime };
  }

  const getDate =
    includeToday && config.getDateIncludeToday ? config.getDateIncludeToday : config.getDate;

  return { dates: toUnixRange(getDate()), rangeTime };
};
